// extracted by mini-css-extract-plugin
module.exports = {"container":"WeAreIn_container__3JNHq","paragraph":"WeAreIn_paragraph__LdSCT"};